import React from 'react'
import { useForm } from 'react-hook-form'
import { ReportFormContent } from './ReportFormContent'
import { FREQUENCY, TIME_SLOTS, TIME_ZONES, WEEKDAYS } from '@/utilities'
import { ModalFooter, Button, Loading } from '@maui/elements'
import { useDeliveryProfile } from './useDeliveryProfile'

// The original delivery profile form
export const LegacyReportForm = ({
  user,
  onClose,
  hasEntitlements,
  editData = {},
}) => {
  const { data, onSubmit, isLoading, isSubmitting } = useDeliveryProfile({ user, onClose, editData })

  const { handleSubmit, control, register, formState: { errors, isValid, isDirty } } = useForm({
    defaultValues: {
      name: '',
      emailAddress: user.email,
      levelOfDetail: 'REPORT',
      deliveryFreq: FREQUENCY[1].value,
      deliveryDays: WEEKDAYS.map(w => w.value),
      deliveryTime: TIME_SLOTS[0].value,
      enableDayLightSavings: [],
      timeZone: TIME_ZONES[0].value,
      includeIndicators: false,
      format: [],
      intelPackages: data?.intelPackages || [],
      vulnRiskRating: data?.vulnRiskRating || [],
    },
    values: data
  })

  if (editData?.id && isLoading) {
    return <Loading />
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ReportFormContent
        control={control}
        register={register}
        errors={errors}
        deliveryFreq={data?.deliveryFreq}
        hasEntitlements={hasEntitlements}
      />
      <ModalFooter mt="spaceGapXxLarge" gap="spaceGapMedium">
        { isSubmitting && <Loading /> }
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>Cancel</Button>
        <Button marginLeft="spaceGapXLarge" type="submit" disabled={isSubmitting || !isValid || !isDirty}>Save</Button>
      </ModalFooter>
    </form>
  )
}
